/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Commentlabel3Inputs */

const en_coinvestments_declinedeal_commentlabel3 = /** @type {(inputs: Coinvestments_Declinedeal_Commentlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments`)
};

/**
* | output |
* | --- |
* | "Comments" |
*
* @param {Coinvestments_Declinedeal_Commentlabel3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_commentlabel3 = /** @type {((inputs?: Coinvestments_Declinedeal_Commentlabel3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Commentlabel3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_commentlabel3(inputs)
});
export { coinvestments_declinedeal_commentlabel3 as "coInvestments_declineDeal_commentLabel" }